import React from 'react';
import { Card } from 'reactstrap';

const SeverityDescriptions: React.FC = () => {
  return (
    <Card className="p-1 overflow-auto">
      <h5>Severity Level of Vulnerability</h5>
      <table
        className="table table-bordered table-striped table-hover"
        style={{
          maxWidth: '600px',
          tableLayout: 'fixed',
        }}
      >
        <thead className="thead-light">
          <tr>
            <th className="p-1" style={{ width: '80px', textAlign: 'left' }}>
              Level
            </th>
            <th className="p-1" style={{ width: '100%', textAlign: 'left' }}>
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Minimal
            </td>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Intruders can collect information about the host (open ports,
              services, etc.) and may be able to use this information to find
              other vulnerabilities.
            </td>
          </tr>
          <tr>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Medium
            </td>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Intruders may be able to collect sensitive information from the
              host, such as the precise version of software installed. With this
              information, intruders can easily exploit known vulnerabilities
              specific to software versions.
            </td>
          </tr>
          <tr>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Serious
            </td>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Intruders may be able to gain access to specific information
              stored on the host, including security settings. This could result
              in potential misuse of the host by intruders. For example,
              vulnerabilities at this level may include partial disclosure of
              file contents, access to certain files on the host, directory
              browsing, disclosure of filtering rules and security mechanisms,
              denial of service attacks, and unauthorized use of services, such
              as mail-relaying.
            </td>
          </tr>
          <tr>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Critical
            </td>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Intruders can possibly gain control of the host, or there may be
              potential leakage of highly sensitive information. For example,
              vulnerabilities at this level may include full read access to
              files, potential backdoors, or a listing of all the users on the
              host.
            </td>
          </tr>
          <tr>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Urgent
            </td>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Intruders can easily gain control of the host, which can lead to
              the compromise of your entire network security. For example,
              vulnerabilities at this level may include full read and write
              access to files, remote execution of commands, and the presence of
              backdoors.
            </td>
          </tr>
        </tbody>
      </table>
    </Card>
  );
};

export default SeverityDescriptions;
